<nz-spin [nzSpinning]="loading">
  <nz-row>
    <nz-col [nzFlex]="8">
      <form nz-form [formGroup]="form" (ngSubmit)="submitForm()">
        <nz-form-item>
          <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="name">
            <span>Name</span>
          </nz-form-label>
          <nz-form-control [nzSm]="14" [nzXs]="24">
            <input
              nz-input
              id="name"
              disabled
              #nameInput
              [value]="eventDisplayName"
              />
          </nz-form-control>
        </nz-form-item>

        @if (isEdit) {
          <nz-form-item>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="orderNumber">
              <span>Nummer</span>
            </nz-form-label>
            <nz-form-control [nzSm]="14" [nzXs]="24">
              <input nz-input id="orderNumber" formControlName="orderNumber" />
            </nz-form-control>
          </nz-form-item>
        }

        <nz-form-item>
          <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="seats" nzRequired>
            <span>Sitze</span>
          </nz-form-label>
          <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Sitze ist erforderlich!">
            <input nz-input id="seats" formControlName="seats" type="number" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="beginning" nzRequired>
            <span>Datum und Uhrzeit</span>
          </nz-form-label>
          <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Datum und Uhrzeit ist erforderlich!">
            <nz-date-picker
              formControlName="beginning"
              nzFormat="dd.MM.yyyy HH:mm"
              [nzShowTime]="{ nzFormat: 'dd.MM.yyyy HH:mm' }"
              [nzDisabledDate]="disableDatesBeforeNow"
            ></nz-date-picker>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="leader">
            <span>Leiter</span>
          </nz-form-label>
          <nz-form-control [nzSm]="14" [nzXs]="24">
            <input nz-input id="leader" formControlName="leader" type="text" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="comment">
            <span>Kommentar</span>
          </nz-form-label>
          <nz-form-control [nzSm]="14" [nzXs]="24">
            <textarea rows="4" nz-input formControlName="comment"></textarea>
          </nz-form-control>
        </nz-form-item>


        <nz-form-item>
          <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="comment">
            <span>Inaktiv im Shopware</span>
          </nz-form-label>
          <nz-form-control [nzSm]="14" [nzXs]="24">
            <label nz-checkbox formControlName="isInactiveInShopware">Ja/Nein</label>
          </nz-form-control>
        </nz-form-item>
      </form>
    </nz-col>
  </nz-row>
</nz-spin>
